import * as React from "react";
import createDynamicImportWithRetry from "./retryDynamicImport";
import { ChunkErrorSessionManager } from "./ChunkErrorSessionManager";

ChunkErrorSessionManager.cleanupStaleReloadFlag();

const defaultDynamicImportWithRetry = createDynamicImportWithRetry(5);

function lazyWithRetries(importer: () => Promise<any>) {
  return React.lazy(() => defaultDynamicImportWithRetry(importer));
}

export default lazyWithRetries;